<template v-if="ready">
    <div ref="loader" class="mt-2">
        <b-container class="container-lg">
            <b-row class="pb-2">
                <b-col class="text-start">
                    <h5><i class="fa-solid fa-gauge-high"></i> {{ $t('Dashboard') }}</h5>
                </b-col>
                <b-col class="text-end">
                    <button class="btn btn-light btn-sm" type="button" @click="refreshData">
                        <i :class="{'fa-spin': loading}"
                           class="fa-solid fa-arrows-rotate"></i>
                    </button>
                </b-col>
            </b-row>
            <div>
                <b-card-group class="mb-2 d-none d-lg-block" deck>
                    <b-card :header="$t('user')" class="text-center fw-bold">
                        <b-card-text>
                            {{ $t('welcome') }} {{ this.$store.state.user }}
                        </b-card-text>
                    </b-card>
                </b-card-group>

                <b-card class="mb-2 border-bottom-1 rounded-bottom-1">
                    <div class="row">
                        <b-button-group class="w-100">
                            <button class="w-100 btn btn-primary"
                                    type="button"
                                    @click="pushTo('dashboardsIndex')">
                                <i class="fa-solid fa-layer-group"></i>
                                {{ $t('Overview') }}
                            </button>
                            <!--<button type="button"
                                    class="w-50 btn btn-light"
                                    @click="pushTo('dashboardsStatuspagegroups')">
                              <i class="fa-solid fa-layer-group"></i>
                              {{ $t('Slas') }}
                            </button>-->

                        </b-button-group>
                    </div>
                    <div class="row">
                        <b-button-group class="w-100">
                            <button class="w-50 btn btn-light"
                                    type="button"
                                    @click="pushTo('dashboardsAlerts')">
                                <i class="fa-solid fa-bell"></i>
                                {{ $t('Alerts') }}
                            </button>
                            <button class="w-50 btn btn-light"
                                    type="button"
                                    @click="pushTo('dashboardsTacticals')">
                                <i class="fa-solid fa-chart-area"></i>
                                {{ $t('Tacticals') }}
                            </button>

                        </b-button-group>
                    </div>
                    <div class="row">
                        <b-button-group class="w-100">
                            <button class="w-50 btn btn-light"
                                    type="button"
                                    @click="pushTo('dashboardsStatuspages')">
                                <i class="fa-solid fa-info-circle"></i>
                                {{ $t('Statuspages') }}
                            </button>
                            <button class="w-50 btn btn-light"
                                    type="button"
                                    @click="pushTo('dashboardsStatuspagegroups')">
                                <i class="fa-solid fa-layer-group"></i>
                                {{ $t('Statuspage groups') }}
                            </button>
                        </b-button-group>
                    </div>
                </b-card>


                <b-card-group deck>
                    <b-card :header="$t('dashboard.hoststats')" class="mb-2">
                        <template #header>
                            <span class="fw-bold">
                                {{ $t('dashboard.hoststats') }}
                            </span>
                            <router-link :to="{name: 'hostsIndex', params: {}}"
                                         class="btn btn-primary float-end">
                                {{ $t('all') }}
                                <b-badge pill variant="light">{{ indexData.hosts.total }}</b-badge>
                            </router-link>
                        </template>
                        <b-card-text>
                            <div class="row">
                                <div class="col-12" role="button" v-on:click="getHostsIndexByState('up')">
                                    <div class="d-flex mt-2">
                                        {{ $t('up') }}
                                        <span class="d-inline-block ms-auto">{{
                                                indexData.hosts.up
                                            }} / {{ indexData.hosts.total }}</span>
                                    </div>
                                    <b-progress :value="(indexData.hosts.up/indexData.hosts.total*100)"
                                                class="progress-sm mb-3 border-radius-10"
                                                height="0.5rem"
                                                variant="up"></b-progress>
                                </div>
                                <div class="col-12" role="button" v-on:click="getHostsIndexByState('down')">
                                    <div class="d-flex mt-2">
                                        {{ $t('down') }}
                                        <span class="d-inline-block ms-auto">{{
                                                indexData.hosts.down
                                            }} / {{ indexData.hosts.total }}</span>
                                    </div>
                                    <b-progress :value="(indexData.hosts.down/indexData.hosts.total*100)"
                                                class="progress-sm mb-3 border-radius-10"
                                                height="0.5rem"
                                                variant="down"></b-progress>
                                </div>
                                <div class="col-12" role="button" v-on:click="getHostsIndexByState('unreachable')">
                                    <div class="d-flex mt-2">
                                        {{ $t('unreachable') }}
                                        <span class="d-inline-block ms-auto">{{
                                                indexData.hosts.unreachable
                                            }} / {{ indexData.hosts.total }}</span>
                                    </div>
                                    <b-progress :value="(indexData.hosts.unreachable/indexData.hosts.total*100)"
                                                class="progress-sm mb-3 border-radius-10"
                                                height="0.5rem"
                                                variant="unreachable"></b-progress>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <b-button variant="outline-danger w-100" @click="unhandledHosts">
                                        <i class="fa-solid fa-triangle-exclamation warning"></i>
                                        {{ $t('unhandled') }}
                                        <b-badge pill variant="danger">{{ indexData.unhandledHosts.total }}</b-badge>
                                    </b-button>
                                </div>
                            </div>
                        </b-card-text>
                    </b-card>

                    <b-card :header="$t('dashboard.servicestats')" class="mb-2">
                        <template #header>
                            <span class="fw-bold">
                                {{ $t('dashboard.servicestats') }}
                            </span>
                            <router-link :to="{name: 'servicesIndex', params: {}}"
                                         class="btn btn-primary float-end">
                                {{ $t('all') }}
                                <b-badge pill variant="light">{{ indexData.services.total }}</b-badge>
                            </router-link>
                        </template>
                        <b-card-text>
                            <div class="row">
                                <div class="col-12" role="button" v-on:click="getServicesIndexByState('ok')">
                                    <div class="d-flex mt-2">
                                        {{ $t('ok') }}
                                        <span class="d-inline-block ms-auto">{{
                                                indexData.services.ok
                                            }} / {{ indexData.services.total }}</span>
                                    </div>
                                    <b-progress :value="(indexData.services.ok/indexData.services.total*100)"
                                                class="progress-sm mb-3 border-radius-10"
                                                height="0.5rem"
                                                variant="ok"></b-progress>
                                </div>
                                <div class="col-12" role="button" v-on:click="getServicesIndexByState('warning')">
                                    <div class="d-flex mt-2">
                                        {{ $t('warning') }}
                                        <span class="d-inline-block ms-auto">{{
                                                indexData.services.warning
                                            }} / {{ indexData.services.total }}</span>
                                    </div>
                                    <b-progress :value="(indexData.services.warning/indexData.services.total*100)"
                                                class="progress-sm mb-3 border-radius-10"
                                                height="0.5rem"
                                                variant="warning"></b-progress>
                                </div>
                                <div class="col-12" role="button" v-on:click="getServicesIndexByState('critical')">
                                    <div class="d-flex mt-2">
                                        {{ $t('critical') }}
                                        <span class="d-inline-block ms-auto">{{
                                                indexData.services.critical
                                            }} / {{ indexData.services.total }}</span>
                                    </div>
                                    <BProgress :value="(indexData.services.critical/indexData.services.total*100)"
                                               class="progress-sm mb-3 border-radius-10"
                                               height="0.5rem"
                                               variant="critical"></BProgress>
                                </div>
                                <div class="col-12" role="button" v-on:click="getServicesIndexByState('unknown')">
                                    <div class="d-flex mt-2">
                                        {{ $t('unknown') }}
                                        <span class="d-inline-block ms-auto">{{
                                                indexData.services.unknown
                                            }} / {{ indexData.services.total }}</span>
                                    </div>
                                    <b-progress :value="(indexData.services.unknown/indexData.services.total*100)"
                                                class="progress-sm mb-3 border-radius-10"
                                                height="0.5rem"
                                                variant="unknown"></b-progress>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <b-button variant="outline-danger w-100" @click="unhandledServices">
                                        <i class="fa-solid fa-triangle-exclamation warning"></i>
                                        {{ $t('unhandled') }}
                                        <b-badge pill variant="danger">{{ indexData.unhandledServices.total }}</b-badge>
                                    </b-button>
                                </div>
                            </div>
                        </b-card-text>
                    </b-card>
                </b-card-group>
                <div v-if="scmWidgets.length > 0">
                    <template v-for="scm in scmWidgets">
                        <scm-widget :title="scm.title" :type_id="scm.type_id" :widget_id="scm.id"/>
                    </template>
                </div>
                <div v-if="slaStatusWidgets.length > 0">
                    <template v-for="slastatus in slaStatusWidgets">
                        <sla-widget :title="slastatus.title" :type_id="slastatus.type_id" :widget_id="slastatus.id"/>
                    </template>
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>

import router from "../router";
import { useToast } from "vue-toastification";
import Widgets from './dashboard/Widgets.vue';
import ScmWidget from './dashboard/ScmWidget.vue';
import SlaWidget from './dashboard/SlaWidget.vue';
import { BButtonGroup } from 'bootstrap-vue-next';


export default {
    name: "DashboardsIndex",
    components: {
        BButtonGroup,
        Widgets, ScmWidget, SlaWidget
    },
    data() {
        return {
            loading: true,
            requestStatus: false,
            ready: false,
            slas: false,
            scms: false,
            permissions: {},
            indexData: {
                hosts: {
                    total: 0,
                    up: 0,
                    down: 0,
                    unreachable: 0
                },
                services: {
                    total: 0,
                    ok: 0,
                    warning: 0,
                    critical: 0,
                    unknown: 0
                },
                unhandledHosts: {
                    total: 0
                },
                unhandledServices: {
                    total: 0
                }
            },
            hostsFilter: {
                filter: {
                    current_state: [],
                    problem_has_been_acknowledged: '',
                    scheduled_downtime_depth: ''
                }
            },
            servicesFilter: {
                filter: {
                    current_state: [],
                    problem_has_been_acknowledged: '',
                    scheduled_downtime_depth: ''
                }
            },
            statuspageExist: false,
            scmWidgets: [],
            slaStatusWidgets: []
        };
    },
    methods: {
        pushTo: function(name) {
            this.$router.push({name: name});
        },
        async getData(refresh = 0) {
            let loader = this.$loading.show();
            this.loading = true;
            axios.post('/dashboards/index.json')
                .then(response => {
                    this.requestStatus = true;
                    this.permissions = response.data.permissions;
                    if(this.permissions.slamodule) {
                        this.slas = true;
                        this.getSlaStatusWidgets();
                    }
                    if(this.permissions.scmmodule) {
                        this.scms = true;
                        this.getScmWidgets();
                    }
                    this.indexData.hosts.total = response.data.statusData.hoststatusSum;
                    this.indexData.hosts.up = response.data.statusData.hoststatusCount[0];
                    this.indexData.hosts.down = response.data.statusData.hoststatusCount[1];
                    this.indexData.hosts.unreachable = response.data.statusData.hoststatusCount[2];
                    this.indexData.services.total = response.data.statusData.servicestatusSum;
                    this.indexData.services.ok = response.data.statusData.servicestatusCount[0];
                    this.indexData.services.warning = response.data.statusData.servicestatusCount[1];
                    this.indexData.services.critical = response.data.statusData.servicestatusCount[2];
                    this.indexData.services.unknown = response.data.statusData.servicestatusCount[3];

                    this.indexData.unhandledHosts.total = response.data.statusData.unhandledHostsSum;
                    this.indexData.unhandledServices.total = response.data.statusData.unhandledServicesSum;
                    if(refresh === 1) {
                        useToast().success(this.$t('refresh'), {
                            timeout: 2000
                        });
                    }
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    loader.hide();
                    this.loading = false;
                });
        },

        async getScmWidgets() {
            axios.post('/dashboards/scms.json')
                .then(response => {
                    this.scmWidgets = response.data.scmWidgets || [];
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {

                });
        },

        async getSlaStatusWidgets() {
            axios.post('/dashboards/slastatus.json')
                .then(response => {
                    this.slaStatusWidgets = response.data.slaStatusWidgets || [];
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {

                });
        },


        refreshData() {
            this.getData(1);
        },
        unhandledHosts() {
            this.hostsFilter.filter.current_state = [
                'down',
                'unreachable'
            ];
            this.hostsFilter.filter.problem_has_been_acknowledged = false;
            this.hostsFilter.filter.scheduled_downtime_depth = false;
            this.$store.commit('setHostsIndexFilter', this.hostsFilter);
            router.push({name: 'hostsIndexFilter'});
            //router.push({name: 'hostsIndexFilter', params: {filter: JSON.stringify(this.hostsFilter)}});
        },
        unhandledServices() {
            this.servicesFilter.filter.scheduled_downtime_depth = false
            this.servicesFilter.filter.problem_has_been_acknowledged = false
            this.servicesFilter.filter.current_state = [
                'warning',
                'critical',
                'unknown'
            ];
            this.$store.commit('setServicesIndexFilter', this.servicesFilter);
            router.push({name: 'servicesIndexFilter'});
            // router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
        },
        getHostsIndexByState(currentState) {
            this.hostsFilter.filter.current_state = [currentState];
            this.$store.commit('setHostsIndexFilter', this.hostsFilter);
            //router.push({name: 'hostsIndexFilter', params: {filter: JSON.stringify(this.hostsFilter)}});
            router.push({name: 'hostsIndexFilter'});
        },
        getServicesIndexByState(currentState) {
            this.servicesFilter.filter.current_state = [currentState];
            this.$store.commit('setServicesIndexFilter', this.servicesFilter);
            router.push({name: 'servicesIndexFilter'});
            //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
        }
    },
    async mounted() {
        this.emitter.on('statuspage-exist', () => {
            this.statuspageExist = true;
        });
        this.permissions = await this.$store.state.permissions;


        const statuspages = await this.$store.state.statuspages;
        if(statuspages) {
            this.statuspageExist = true;
        }
        await this.getData();


        /* if(this.scms === true) {
           console.log('scms')
           await this.getScmWidgets();
         } */
        this.ready = true;

    }
}
</script>

<style scoped>
</style>
